export default `p.xy = mod( p.xy + 1.0, 2.0 ) - 1.0;
  p.z = abs( p.z ) - 0.75;
  vec4 q = vec4( p, 1.0 );
  for ( int i = 0; i < 15; i++ ) {
    q.xyz = abs( q.xyz ) - vec3( 0.3, 1.0, -0.0 );
    q = 2.0 * q / clamp( dot( q.xyz, q.xyz ), 0.5, 1.0 ) - vec4( 1.0, 0.0, 0.3, 0.0 );
  }
  return abs(q.x + q.y + q.z)/q.w;
}`